const actions = {
    UPDATE_FORMS: "UPDATE_FORMS",
    FORM_SET_FORM_VALUE: 'FORM_SET_FORM_VALUE',

    updateForms: forms => ({
        type: actions.UPDATE_FORMS,
        forms,
    }),
    setFormValue: (form, value) => ({
        type: actions.FORM_SET_FORM_VALUE,
        form,
        value,
    }),
};
export default actions;
